import { apiFetch } from "./apiMedecins.js";
export const PLANNING_PR_CONFIG_ENDPOINT = "/api/v2/desiderata-planning-pr-config";
export const PLANNING_PR_CONFIG_COMPAT_ENDPOINT = "/api/v2/config/desiderata-planning-pr";
export const PLANNING_PR_ACTIVITES_ENDPOINT = "/api/v2/activites-planning-pr";
export const PLANNING_PR_DATA_ENDPOINT = "/api/v2/planning-pr-data";
export const PLANNING_PR_DESIDERATA_ENDPOINT = "/api/v2/desiderata-planning-pr";
export const PLANNING_PR_MEDECINS_ENDPOINT = "/api/v2/medecins-planning-pr";

export function planningPrConfigPayloadToConfig(payload) {
  if (!payload || typeof payload !== "object") return null;
  return payload.config && typeof payload.config === "object" ? payload.config : payload;
}

export async function fetchPlanningPrConfig(options = {}) {
  const res = await apiFetch(PLANNING_PR_CONFIG_ENDPOINT, {
    credentials: "include",
    cache: "no-store",
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} lecture config planning PR. ${text}`);
  }
  return planningPrConfigPayloadToConfig(await res.json());
}

export async function savePlanningPrConfig(payload) {
  const res = await apiFetch(PLANNING_PR_CONFIG_ENDPOINT, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} sauvegarde config planning PR. ${text}`);
  }
  return planningPrConfigPayloadToConfig(await res.json());
}

export function planningPrDesiderataPayloadToOwn(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (payload.data !== undefined) return payload.data;
  if (Array.isArray(payload.desiderata)) return payload.desiderata[0] || null;
  return null;
}
